import { render, staticRenderFns } from "./StepSignature.vue?vue&type=template&id=1ac4bce1&scoped=true"
import script from "./StepSignature.vue?vue&type=script&lang=js"
export * from "./StepSignature.vue?vue&type=script&lang=js"
import style0 from "./StepSignature.vue?vue&type=style&index=0&id=1ac4bce1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac4bce1",
  null
  
)

export default component.exports